import { render, staticRenderFns } from "./ReturnReplacementReceiptAcknowledgment.vue?vue&type=template&id=5440045a"
import script from "./ReturnReplacementReceiptAcknowledgment.vue?vue&type=script&lang=js"
export * from "./ReturnReplacementReceiptAcknowledgment.vue?vue&type=script&lang=js"
import style0 from "./ReturnReplacementReceiptAcknowledgment.vue?vue&type=style&index=0&id=5440045a&prod&scopped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports